<template>
    <div class="template-generator-name">
        {{documentName}}
    </div>
</template>

<script>
export default {
    computed:{
        documentName(){
            if(this.name == "{{documentName}}") {
                if(this.editing) return this.prevName || "Belge İsmi"
                else return "Belge İsmi"
            }
            else return this.name
        }
    },
    props:{
        name:{
            type:String,
            default:"{{documentName}}"
        },
        editing:Boolean,
        prevName:{
            type:String,
            default:null
        }
    }
}
</script>

<style>
.template-generator-name{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: bold;
}
</style>